import { Button, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";

const TableTypeButton = (props) => {
    // Handle new pencil icon mode for module editing
    if (props.icon === "pencil") {
        const handleClick = (e) => {
            e.stopPropagation(); // Prevent row selection
            if (props.onClick) {
                props.onClick("edit", props.children);
            }
        };

        return (
            <Stack direction="horizontal" gap={2} style={{ height: "50px" }}>
                <Button 
                    size="sm" 
                    variant={props.variant || "outline-primary"}
                    onClick={handleClick}
                >
                    <FontAwesomeIcon icon={faPencil} />
                </Button>
            </Stack>
        );
    }

    // Original behavior - if no special icon property is provided
    // Check if children exist and is an array
    if (!props.children || !Array.isArray(props.children)) {
        return <></>; // Return empty if no children
    }

    return (
        <Stack direction="horizontal" gap={0} style={{height: "50px"}}>
            {props.children.map((item, index) => (
                <span key={index}>{item.icon}</span>
            ))}
        </Stack>
    );
};

export default TableTypeButton;